<template>
    <div class="page-main common">
        <div class="spaceCenter" style="max-width:80%;">
          <a-form-model
            class="common-form-inline"
            ref="bindingAddForm"
            :model="pageData"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
            style="width:330px;margin-top:30px;"
            >
                <a-form-model-item label="账户户名" prop="accNm">
                    <span>{{pageData.accNm}}</span>
                </a-form-model-item>
                <a-form-model-item label="账户账号" prop="accNo">
                    <a-input v-model="pageData.accNo" :disabled="pageType=='detail'"/>
                </a-form-model-item>

                <a-form-model-item label="开户银行" prop="accBlngBnk">
                    <a-input v-model="pageData.accBlngBnk" :disabled="pageType=='detail'"/>
                </a-form-model-item>
                <a-form-model-item label="大额行号" prop="largeBankNo">
                    <a-input v-model="pageData.largeBankNo" :disabled="pageType=='detail'"/>
                </a-form-model-item>

                <a-form-model-item label="开户证明" prop="accountOpenCertify">
                    <a-input v-model="pageData.accountOpenCertify" :disabled="true" placeholder="请选择附件"/>
                    <a-upload
                    v-if="pageType!='detail'"
                    class="upload-btn"
                    :file-list="fileList"
                    :before-upload="beforeFileUpload"
                    :showUploadList="false"
                    :customRequest="handleFileUpload"
                    >
                        <a-button :loading="uploading" class="btn-blue-line" style="margin-left:20px;">选择文件 </a-button>
                    </a-upload>
                    <a-button @click="download" v-if="pageType=='detail'" class="btn-blue-line upload-btn" style="margin-left:20px;">附件下载 </a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
        <div class="model-footer-btns spaceCenter" style="max-width:80%;">
            <a-button class="btn-blue-line btn-big" @click="goback">取消</a-button>
            <a-button @click="submit" v-if="pageType!='detail'" class="btn-big" type="primary">确认</a-button>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import {fileSaveAPI} from "@/api/file.js"
import {addBindingAccount,viewBindingAccount,modifyBindingAccount} from "@/api/customer.js"
export default {
    name:"binding-add",
    components: {},
    data() {
        return {
            pageType:"add",
            cstId:"",
            name:"importFile",
            url:"/gb-bigtree-file/fileUpload",
            fileList:[],
            uploading:false,
            pageData: {
                accNm: "",
                accNo:"",
                accBlngBnk:"",
                accountOpenCertify:""
            },
            labelCol: { span: 7 },
            wrapperCol: { span: 17 },
            rules:{
                accNo: [
                    {
                        required: true,
                        trigger: "blur",
                        whitespace:true,
                        validator: (rule, value, cbfn) => {
                            if (! value) {
                                cbfn('请填写账户账号');
                            }
                            if(! /^\d+$/.test(value)){
                                cbfn('账户账号只能输入阿拉伯数字');
                            }
                            if (value.length > 24) {
                                cbfn('账户账号不能超过24位');
                            }
                            cbfn();
                        }
                    }
                ],
                largeBankNo:[
                    {
                        required: true,
                        trigger: "blur",
                        whitespace:true,
                        validator: (rule, value, cbfn) => {
                            if (! value) {
                                cbfn('请填写大额行号');
                            }
                            if(! /^\d+$/.test(value)){
                                cbfn('大额行号只能输入阿拉伯数字');
                            }
                            if (value.length != 12) {
                                cbfn('大额行号需为12位数字');
                            }
                            cbfn();
                        }
                    }
                ],
                accBlngBnk: [
                    {
                        required: true,
                        trigger: "blur",
                        whitespace:true,
                        message:"请填写开户银行"
                    }
                ],
                accountOpenCertify:[
                    {
                        required: true,
                        trigger: "blur",
                        whitespace:true,
                        message:"请填写开户证明"
                    }
                ]
            }
        };
    },
    computed: {
        ...mapGetters({
            userObj:"home/getUserObj",
            getUserHeader:"home/getUserHeader"
        })
    },
    created() {
        this.cstId = this.$route.query.id;
        this.pageType = this.$route.query.type||"add";
        if(this.pageType == "detail"){ //查看
            this.getDetail();
        }
        else if(this.pageType == "add"){ //新建
            this.pageData.accNm = this.userObj.cstNm;
        }
        else if(this.pageType == "edit"){ //变更
            this.getDetail();
        }
    },
    mounted() {

    },
    methods: {
        getDetail(){
            viewBindingAccount({id:this.cstId},true)
            .then(res => {
                this.pageData = res.data;
                if(res.data.accountOpenCertify){
                    let index = res.data.accountOpenCertify.lastIndexOf("/");
                    this.pageData.accountOpenCertifyReal = res.data.accountOpenCertify;
                    this.pageData.accountOpenCertify = this.pageData.accountOpenCertify.substring(index+1, res.data.length);

                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        beforeFileUpload(file){
            this.fileList = [...this.fileList, file];
        },
        handleFileUpload() {
            const formData = new FormData();
            this.fileList.forEach(file => {
                formData.append(this.name, file);
                formData.append('app', 'portal-pc');
                formData.append('module', 'bindingAccount');
                formData.append('user', this.getUserHeader.realname);
                formData.append('tblBlId', this.utils.guid(32, 16));
                formData.append('superFiledId', '1');
                formData.append('mdlId', 'bindingAccount');
            });
            this.uploading = true;
            this.axios({
                url:this.url,
                data:formData,
                isTransform:false
            }).then((res)=> {
                if(res[0]){
                    this.fileSave(res[0]);
                }
            })
            .catch((data)=> {
                if(data[0]){
                    this.fileSave(data[0]);
                }
            });
        },
        fileSave(data){
            this.certifyUri = data.savePath ? `${JSON.parse(data.savePath).file}/${data.originalFilename}` : '';
            const param = {
                fileNm: data.originalFilename,
                fileSize: data.size,
                fileRte: data.savePath ? `${JSON.parse(data.savePath).file}` : '',
                fileExpdNm: data.contentType,
                tblBlId: this.utils.guid(32, 16),
                mdlId: 'bindingAccount',
                superFiledId: '1'
            }
            fileSaveAPI(param)
            .then(res => {
                this.uploading = false;
                this.pageData.accountOpenCertify = data.originalFilename;
            })
            .catch(err => {
                this.uploading = false;
                console.log(err);
            })
        },
        submit(){
            this.$refs.bindingAddForm.validate((vaild) => {
                if(vaild){
                    if(this.pageType == "add"){
                        this.addFun();
                    }
                    else if(this.pageType == "edit"){
                        this.editFun();
                    }
                }
            })

        },
        addFun(){
            const param = {
                cstId: this.cstId,
                accNm: this.pageData.accNm,
                accNo: this.pageData.accNo,
                accBlngBnk: this.pageData.accBlngBnk,
                largeBankNo:this.pageData.largeBankNo,
                accountOpenCertify:this.certifyUri||this.pageData.accountOpenCertifyReal
            };
            addBindingAccount(param,true)
            .then(res => {
                this.$message.success("提交成功");
                this.goback();
            })
            .catch(err => {
                console.log(err);
            })
        },
        editFun(){
            const param = {
                id: this.cstId,
                accNm: this.pageData.accNm,
                accNo: this.pageData.accNo,
                accBlngBnk: this.pageData.accBlngBnk,
                largeBankNo:this.pageData.largeBankNo,
                accountOpenCertify:this.certifyUri || this.pageData.accountOpenCertifyReal
            };
            modifyBindingAccount(param,true)
            .then(res => {
                this.$message.success("提交成功");
                this.goback();
            })
            .catch(err => {
                console.log(err);
            })
        },
        download() {
            const DOWNLOAD_PREFIX = '/gb-bigtree-file/download/fileDownload/install';
            if (this.pageData.accountOpenCertifyReal && this.pageData.accountOpenCertifyReal !== 'undefined') {
                window.open(`${DOWNLOAD_PREFIX}${this.pageData.accountOpenCertifyReal}`);
                return;
            }
        },
        goback(){
            this.$router.push("/account/binding");
        }
    },
    watch: {},

};
</script>
<style scoped>
.upload-btn{
    position: absolute;
    right: -118px;
    top:-11px;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/binding/binding-add.vue